export const colors = {
  primaryColor : "#69d900",
  secondaryColor : "#0f0f0f",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(108deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 41.4%, rgba(105, 217, 0, 0.49) 82.8%, rgba(105, 217, 0, 0.24) 124.19%))",
darkColor:"#5bba01"
}